import { FC, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { TwitterPicker } from 'react-color'
import { useCreateTagMutation } from '../../../../../../../services/cellcast'
import { useContactCreateListMutation } from '../../../../../../../services/cellcast.v2'
import { useUpsertTagMutation } from '../../../../../../../services/cellcast.v3'

import { toast } from 'react-toastify'
import { GetCurrentData } from '../../../../../../Utils/_helpers/GetCurrentData'
import { defaultRegion } from '../../../../../../../_metronic/helpers'

export enum CreateTagModalMode {
  Tag = 'tag',
  List = 'list',
}

export type CreateTagModalProps = {
  mode: CreateTagModalMode
  show: boolean
  handleClose: () => void
  handleCallback: (data?: any) => void
}

const CreateTagModal: FC<CreateTagModalProps> = (props) => {
  const currentUser = GetCurrentData();

  const { mode, show, handleCallback, handleClose } = props
  const [name, setName] = useState('')
  const [color, setColor] = useState('#7bdcb5')
  const [error, setError] = useState('')

  const [createTag, tagResponse] = useCreateTagMutation()
  const [createList, listResponse] = useContactCreateListMutation()
  const [upsertTag] = useUpsertTagMutation();

  const handleChangeColor = (color: any) => {
    setColor(color.hex)
  }

  const handleCreate = () => {
    if (mode === CreateTagModalMode.Tag) {
      createTag({
        name: name,
        color: color,
      }).then((res) => {
        if ('data' in res) {
          toast.success(res?.data?.message)
          if (handleCallback) {
            handleCallback(res?.data?.data)
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
    } else {
      createList({
        name: name,
      }).then((res) => {
        if ('data' in res) {
          if (typeof res?.data?.data !== 'object') {
            toast.error(res.data?.message)
          } else {
            toast.success(res?.data?.message)
            if (handleCallback) {
              handleCallback(res?.data?.data)
            }
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
    }
  }

  const handleCreateV3 = async () => {
    const result = await upsertTag({
      action: 'create_tag',
      data: {
        name: name,
        color: color,
        type: mode
      }
    }).unwrap();
    if (!result?.data?.is_error) {
      toast.success(result?.data?.message)
      if (handleCallback) {
        handleCallback(result?.data)
      }
    } else if (result?.data?.is_error) {
      toast.error(result?.data?.message)
    }
  }

  return (
    <Modal
      backdrop='static'
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-550px'
      className='vh-100'
      show={show}
      onHide={handleClose}
    >
      <>
        <div className='modal-header'>
          <h1>Create new {mode === CreateTagModalMode.Tag ? 'tag' : 'list'}</h1>
        </div>
        <div className='modal-body'>
          <label className='w-100'>
            <span
              style={{
                color: '#5F6276',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              {mode === CreateTagModalMode.Tag ? 'Tag' : 'List'} name
            </span>
            <input
              onBlur={() => {
                ; /^[a-zA-Z0-9_ -]{2,25}$/.test(name)
                  ? setError('')
                  : setError('please enter valid tag ')
              }}
              placeholder='Tag name'
              maxLength={25}
              className='form-control form-control-solid border-0 w-100 mt-2'
              onChange={(e: any) => {
                setError('')
                setName(e.target.value)
              }}
            />
            {name && mode === CreateTagModalMode.Tag && (
              <>
                <label className=' col-form-label required fw-bold fs-6'>Color</label>
                <div
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-white'
                  style={{ backgroundColor: color }}
                >
                  {name}
                </div>

                <TwitterPicker
                  onChange={handleChangeColor}
                  triangle='hide'
                  colors={[
                    '#D9E3F0',
                    '#F47373',
                    '#697689',
                    '#37D67A',
                    '#2CCCE4',
                    '#555555',
                    '#dce775',
                    '#ff8a65',
                    '#ba68c8',
                    '#22194D',
                  ]}
                />
              </>
            )}
            <span className='text-danger mt-1'>{error}</span>
            {mode === CreateTagModalMode.Tag && (
              <span
                style={{
                  color: '#a1a5b7',
                  fontSize: '12px',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                Tag name must consist of; Alphanumeric characters and underscores. Max length 25
                characters with no spaces.
              </span>
            )}
          </label>
        </div>
        <div className='modal-footer w-100'>
          <button onClick={handleClose} type='button' className='btn btn-light-primary'>
            Cancel
          </button>
          <button
            disabled={
              error !== '' || name === '' || tagResponse.isLoading || listResponse.isLoading
            }
            onClick={() => currentUser?.region === defaultRegion ? handleCreate() : handleCreateV3()}
            id='submit'
            type='button'
            className='btn btn-primary w-50 '
          >
            {tagResponse.isLoading || listResponse.isLoading ? (
              <Spinner animation='grow' size='sm' />
            ) : (
              `Create ${mode === CreateTagModalMode.Tag ? 'tag' : 'list'}`
            )}
          </button>
        </div>
      </>
    </Modal>
  )
}

export default CreateTagModal
